// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__ruyhs","empty":"ModalGraph_empty__2qASg"};